import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

// Define the store
interface ShippingModeStore {
  shippingModes: any; // Array of shipping mode names
  addShippingMode: (mode: any) => void; // Function to add a mode
  removeShippingMode: (mode: number) => void; // Function to remove a mode
  clearShippingModes: () => void; // Function to clear all modes
  setShippingModes:(newShippingModes:any)=>void;
}

export const useShippingModeStore = create<ShippingModeStore>()(
  persist(
    (set) => ({
      shippingModes: [
        // "Truck-Air Ride",
        // "Truck-Leaf Ride",
        // "Rail",
        // "Air",
        // "OceanShip",
        // "Others",
        // "Mode 1",
      ], // Initial empty array

      // Add a new shipping mode to the array
      addShippingMode: (mode: any) =>
        set((state) => ({
          shippingModes: [...state.shippingModes, mode],
        })),

      // Remove a shipping mode from the array
      removeShippingMode: (mode: number) =>
        set((state) => ({
          shippingModes: state.shippingModes.filter((m:any) => m.mode !== mode+1),
        })),

      // Clear all shipping modes
      clearShippingModes: () => set({ shippingModes: [] }),
      setShippingModes:(newShippingModes)=>set({
        shippingModes:newShippingModes
      })
    }),
    {
      name: "shipping-modes", // Name of the key in sessionStorage
      storage: createJSONStorage(() => sessionStorage), // Use sessionStorage instead of localStorage
    }
  )
);
